import { Injectable, inject } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { Observable, lastValueFrom, map } from "rxjs";
import { AdvancedSystemTypesApi } from "../apis/advanced-system-types.api";
import { AdvancedSystemTypes } from "../models/advanced-system-types.model";

interface AdvancedSystemTypesTypeaheadOptions {
    manufacturerId?: number;
}

@Injectable()
export class AdvancedSystemTypesTypeaheadApi extends NiceAsyncTypeaheadProvider<AdvancedSystemTypes> {
    public readonly resource = "advancedSystemTypes";
    private readonly pageSize = 20;

    private readonly api = inject(AdvancedSystemTypesApi);

    public override async getById(id: number): Promise<AdvancedSystemTypes> {
        return lastValueFrom(this.api.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number,
        options?: AdvancedSystemTypesTypeaheadOptions
    ): Observable<NiceAsyncTypeaheadSearchResult<AdvancedSystemTypes>> {
        return this.api
            .search({
                manufacturerId: options?.manufacturerId,
                page,
                pageSize: this.pageSize,
                searchQuery
            })
            .pipe(
                map(items => ({
                    items,
                    nextPage: items.length === this.pageSize ? page + 1 : null
                }))
            );
    }

    public override format(advancedSystemType: AdvancedSystemTypes): string {
        if (!isPropertyDefined(advancedSystemType, "value")) {
            return "";
        }

        if (typeof advancedSystemType.value !== "string") {
            return "";
        }

        return advancedSystemType.value;
    }
}
